// The `wire` helper only deals with simple states. We need to add the
// detail sub-states as well, so we'll just do it by hand here.
let module = angular.module('app.pages.reports', []);

module.config(($stateProvider) => {
  'ngInject';

  $stateProvider
    .state('reports', {
      url: '/reports',
      template: require('./reports.html'),
      abstract: true,
    })
    .state('reports.viewer', {
      url: '/viewer?report&id&preset&since&until',
      template: require('./viewer.html'),
      controller: require('./viewer').default,
      controllerAs: 'vm',
    })
    .state('reports.donations', {
      url: '/donations',
      template: require('./donations.html'),
      controller: require('./donations').default,
      controllerAs: 'vm',
    })
    .state('reports.tickets', {
      url: '/tickets?report&id',
      template: require('./tickets.html'),
      controller: require('./tickets').default,
      controllerAs: 'vm',
    });
});

require('./components');

export default module;



// WEBPACK FOOTER //
// ./app/pages/reports/_index.js